import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
var _excluded = ["children"];
import uuid from 'uuid/v4';
var Fragment = 'Fragment';

// Handles the different cases of React's fragment component
var isReactFragment = function isReactFragment(type) {
  return type === 'Symbol(react.fragment)' || type === 'fragment' || type === undefined;
};

// Filter out any children that contain only whitespace
var filterEmptyReactChildren = function filterEmptyReactChildren(children) {
  // Ensuring children is an array here as single elements will be an object
  // React.Children.toArray is not used as certain components could be passing JSX as an object to elementToForgeDoc
  var childrenAsArray = Array.isArray(children) ? children : [children];
  return childrenAsArray.filter(function (child) {
    return !!child && (typeof child !== 'string' || child.trim() !== '');
  });
};
// converts react element(s) to forgeDoc(s) recursively
// and additionally prune and cleanup unnecessary empty fragments
var elementToForgeDocConversionWithFragmentHandling = function elementToForgeDocConversionWithFragmentHandling(elem) {
  var isRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // Handles string child for components
  if (typeof elem === 'string' || typeof elem === 'number') {
    return {
      type: 'String',
      props: {
        text: elem
      },
      children: []
    };
  } else if (Array.isArray(elem)) {
    return elem.flatMap(function (e) {
      return elementToForgeDocConversionWithFragmentHandling(e);
    });
  } else if (_typeof(elem) === 'object') {
    var _elem$type;
    var type = (_elem$type = elem.type) === null || _elem$type === void 0 ? void 0 : _elem$type.toString();
    var key = uuid();
    if (isReactFragment(type)) {
      type = Fragment;
      if (!isRoot) {
        var _children = elem.props.children;
        return elementToForgeDocConversionWithFragmentHandling(filterEmptyReactChildren(_children));
      }
    }

    // Remove children from props as we handle them separately
    var _elem$props = elem.props,
      children = _elem$props.children,
      rest = _objectWithoutProperties(_elem$props, _excluded);
    var props = rest;
    return {
      type: type,
      key: key,
      props: props,
      children: elementToForgeDocConversionWithFragmentHandling(filterEmptyReactChildren(children))
    };
  }
  throw new Error("Can't create ForgeDoc from ".concat(elem));
};

// This function simulates the same behaviour of the ForgeReconciler from `@forge/react`
// to be used for converting elements to forgedoc within this package
export var elementToForgeDoc = function elementToForgeDoc(elem) {
  var forgeDoc = elementToForgeDocConversionWithFragmentHandling(elem, true);
  if (Array.isArray(forgeDoc)) {
    throw new Error('Multiple root fragments are not supported');
  }
  return forgeDoc;
};